<template>
  <table class="table table-striped table-sm">
    <thead>
      <tr style="width: 100%">
        <th scope="col">Data urodzenia</th>
        <th scope="col">Nr konta</th>
        <th scope="col">Portfel</th>
        <th scope="col">Status pracownika</th>
        <th scope="col">Zwer. konto bank?</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          {{
            userDetails.user_profile
              ? userDetails.user_profile.profile.birthdate
              : "-"
          }}
        </td>
        <td>
          {{
            userDetails.user_profile
              ? userDetails.user_profile.profile.account_number
              : "-"
          }}
        </td>
        <td>
          {{ userDetails.user_profile ? userDetails.user_profile.wallet : "-" }}
        </td>
        <td>
          {{
            userDetails.user_profile
              ? userDetails.user_profile.profile.employee_status
              : "-"
          }}
        </td>
        <td>
          {{
            userDetails.user_profile
              ? userDetails.user_profile.profile
                  .is_employee_profile_verified === false
                ? "Nie"
                : "Tak"
              : "-"
          }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["userDetails"],
};
</script>
<style scoped>
.table thead tr th {
  font-size: 16px;
  font-weight: 600;
  border: 1px solid rgba(9, 7, 65, 0.25);
}
.table tbody tr td {
  background: #fff;
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  border: 1px solid rgba(9, 7, 65, 0.25);
}
</style>
